export enum EElectronTargetOS {
  Windows = "win",
  MacOS = "mac",
  Linux = "linux"
}

export enum EElectronArchitecture {
  x64 = "x64",
  arm64 = "arm64"
}

export enum ELinuxPackageFormat {
  AppImage = "appimage",
  Deb = "deb",
  Rpm = "rpm",
  Pacman = "pacman"
}

export interface IElectronConfig {
  serverUrl: string;
  appName: string;
  appId: string;
  appVersion: string;
  targetPlatforms: EElectronTargetOS[];
  targetArchitectures: EElectronArchitecture[];
  linuxPackageFormats: ELinuxPackageFormat[];
  appIconFileName: string | null;
}
